
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 8"}},[_c('path',{attrs:{"d":"M43.405 15.83V7.25a1 1 0 00-1-1h-7.622V4.177a1 1 0 00-1-1H29.67a1 1 0 00-1 1V6.25h-9.496V4.177a1 1 0 00-1-1H14.06a1 1 0 00-1 1V6.25H5.587a1 1 0 00-1 1v36.573a1 1 0 001 1h36.826a1 1 0 001-1V15.87c0-.014-.007-.026-.008-.04zM30.67 5.178h2.113v5.384H30.67V5.177zm-15.609 0h2.113v5.384H15.06V5.177zm-2 3.073v3.311a1 1 0 001 1h4.113a1 1 0 001-1V8.25h9.496v3.311a1 1 0 001 1h4.113a1 1 0 001-1V8.25h6.622v6.62H6.587V8.25zM6.588 42.823v-25.95h34.825v25.95z"}}),_c('path',{attrs:{"d":"M15.56 20.288h-5.497a1 1 0 00-1 1v5.496a1 1 0 001 1h5.497a1 1 0 001-1v-5.496a1 1 0 00-1-1zm-1 5.496h-3.497v-3.496h3.497zM26.748 20.288h-5.496a1 1 0 00-1 1v5.496a1 1 0 001 1h5.496a1 1 0 001-1v-5.496a1 1 0 00-1-1zm-1 5.496h-3.496v-3.496h3.496zM37.938 20.288H32.44a1 1 0 00-1 1v5.496a1 1 0 001 1h5.496a1 1 0 001-1v-5.496a1 1 0 00-1-1zm-1 5.496H33.44v-3.496h3.496zM15.56 31.909h-5.497a1 1 0 00-1 1v5.496a1 1 0 001 1h5.497a1 1 0 001-1v-5.496a1 1 0 00-1-1zm-1 5.496h-3.497v-3.496h3.497zM26.748 31.909h-5.496a1 1 0 00-1 1v5.496a1 1 0 001 1h5.496a1 1 0 001-1v-5.496a1 1 0 00-1-1zm-1 5.496h-3.496v-3.496h3.496zM37.938 31.909H32.44a1 1 0 00-1 1v5.496a1 1 0 001 1h5.496a1 1 0 001-1v-5.496a1 1 0 00-1-1zm-1 5.496H33.44v-3.496h3.496z"}})])])
          )
        }
      }
    